const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const reviewHost = publicConfig.external_address;

// private

function _readReviews(path, token, callback) {
  const params = {
    host: reviewHost,
    method: 'GET',
    path: `/v1/reviews/${path}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  httpLib.request(params, function (res) {
    callback(res);
  });
}

function _updateReview(reviewId, token, payload, callback) {
  const params = {
    host: reviewHost,
    method: 'PUT',
    path: `/v1/reviews/${reviewId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  httpLib.request(
    params,
    function (res) {
      callback(res);
    },
    payload
  );
}

const getReviewsByUser = (
  token,
  SSOid,
  limit = 10,
  offset = 0,
  includeTotal = false,
  publicParam = 'all'
) =>
  new Promise((resolve, reject) => {
    const path = `user/${SSOid}?limit=${limit}&offset=${offset}public=${publicParam}&include_total=${includeTotal}`;

    _readReviews(path, token, (res) => {
      if (res.error) {
        return reject(res);
      }
      resolve(res);
    });
  });

const getReviewsOfUser = (
  token,
  SSOid,
  limit = 10,
  offset = 0,
  includeTotal = false
) =>
  new Promise((resolve, reject) => {
    const path = `guest/${SSOid}?limit=${limit}&offset=${offset}&include_total=${includeTotal}`;
    _readReviews(path, token, (res) => {
      if (res.error) {
        return reject(res);
      }
      resolve(res);
    });
  });

const getReviewsOfSpace = (
  token,
  spaceId,
  limit = 10,
  offset = 0,
  includeTotal = false
) =>
  new Promise((resolve, reject) => {
    const path = `space/${spaceId}?limit=${limit}&offset=${offset}&include_total=${includeTotal}`;
    _readReviews(path, token, (res) => {
      if (res.error) {
        return reject(res);
      }
      resolve(res);
    });
  });

// public
const Reviews = {
  /**
   *
   * @function
   * @name get review
   * @param {String}   - path string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */

  read: (path, token, callback) => {
    const readReviews = _readReviews(path, token, callback);
    return readReviews;
  },

  /**
   *
   * @function
   * @name get review
   * @param {String}   - reviewId string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Object}   - payload
   * @param {Function} - Callback
   */

  update: (reviewId, token, payload, callback) => {
    const updateReview = _updateReview(reviewId, token, payload, callback);
    return updateReview;
  },

  getReviewsByUser,
  getReviewsOfUser,
  getReviewsOfSpace,
};

module.exports = Reviews;
